import { CrudServiceBase } from './CrudServiceBase';
import { FeeDesignationDto } from '@/models/Fees/FeeDesignationDto';
import { FeeTypeDto } from '@/models/Fees/FeeTypeDto';

export class FeeDesignationService extends CrudServiceBase<FeeDesignationDto> {
  constructor(baseUrl: string) {
    super(baseUrl);
  }

  async getTypes() : Promise<FeeTypeDto[]> {
    return await this.client.get('/types');
  }
}